export enum UserStatus {
  NEW_USER = "NEW_USER",
  EMAIL_VERIFIED = "EMAIL_VERIFIED",
  PROFESSIONAL_VERIFIED = "PROFESSIONAL_VERIFIED",
  DISABLED = "DISABLED",
}
